import axios from '@axios'

export default {
  namespaced: true,
  state: {
    tabela_precos: [],
  },
  getters: {},
  mutations: {},
  actions: {
    findAllTabelaPreco(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/tabela-precos', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    findTabelaPrecoById(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/tabela-precos/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    deleteTabelaPrecoById(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`/tabela-precos/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    addTabelaPreco(ctx, dataForm) {
      return new Promise((resolve, reject) => {
        axios
          .post('/tabela-precos', dataForm)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    updatedTabelaPreco(ctx, dataForm) {
      return new Promise((resolve, reject) => {
        if (dataForm.data_termino_validade === '') {
          dataForm.data_termino_validade = null
        }

        if (dataForm.data_inicio_validade === '') {
          dataForm.data_inicio_validade = null
        }

        axios
          .put(`/tabela-precos/${dataForm.id}`, { ...dataForm })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
